<router-outlet></router-outlet>
<ngx-spinner>
  <p style="font-size: 20px; color: white;">Loading...</p>
</ngx-spinner>
